<div
  dragula="CLICKS"
  [dragulaModel]="list"
  (dragulaModelChange)="list = $event; listChange()"
  id="left"
>
  <div *ngIf="getLoadingPenalties$ | async" class="loading-sppiner">
    {{ 'loadingpenalty.text_1' | translate }}
    <div class="loader"></div>
  </div>
  <div *ngIf="!(getLoadingPenalties$ | async)">
    <div class="response-empty" *ngIf="list && list.length == 0">
      {{ 'loadingpenalty.text_2' | translate }}
    </div>

    <div *ngFor="let item of list; let i = index">
      <app-accordion
        [isSelected]="i === 0"
        theme="penalty"
        [contentOverflow]="true"
        size="3em"
        [arrowRight]="true"
        [fullColumn]="true"
        maxHeight="45vh"
      >
        <div class="drag-cursor tab-title" title>
          <div class="columns is-vcentered">
            <div class="column is-1 pl-4">
              <em *ngIf="i === 0" class="mdi mdi-check mdi-16px" aria-hidden="true"></em>
            </div>
            <div class="column is-1 pl-0">
              <em class="mdi mdi-drag mdi-18px" aria-hidden="true"></em>
            </div>
            <div class="column pl-0">{{ item.fareBasis }}</div>
          </div>
        </div>
        <div class="p-3" content>
          <div *ngFor="let category of item?.categories" class="p-1">
            <div class="weight-medium">
              {{ 'exception-mode.category' | translate | uppercase }}
              {{ category.code }}
            </div>
            <div [innerHTML]="highlight(category.freeText)"></div>
          </div>
        </div>
      </app-accordion>
    </div>
  </div>
</div>
